export default "__VITE_ASSET__n$FApCkl__"